import { render, staticRenderFns } from "./ModalMobileChat.vue?vue&type=template&id=ff3bd5b6&"
import script from "./ModalMobileChat.vue?vue&type=script&lang=js&"
export * from "./ModalMobileChat.vue?vue&type=script&lang=js&"
import style0 from "./ModalMobileChat.vue?vue&type=style&index=0&id=ff3bd5b6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports